import { Reveal, SectionLabel } from "./ui";
import RichHTML from "../RichHTML";
import { BadgeCheck, User, Linkedin } from "lucide-react";

export default function About({ about, index, appr }) {
  return (
    <section id="inhaber" style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        {/* photo */}
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative aspect-[4/5] max-w-md">
              {about?.image ? (
                <img src={about.image} alt={`Foto von ${about?.name}`} className="w-full h-full object-cover grayscale-[0.15]" />
              ) : (
                <div className="w-full h-full bg-[var(--mf-mist)] border border-[var(--mf-line)] flex flex-col items-center justify-center text-center px-8 mf-grain overflow-hidden relative">
                  <img src="/mfmed-logo.png" alt="MF MED" className="h-16 w-auto opacity-50" />
                  <User size={40} strokeWidth={1} className="text-[var(--mf-grey)] mt-6" />
                  <p className="mt-4 font-head font-semibold text-[var(--mf-ink)]">Foto von {about?.name}</p>
                  <p className="text-xs text-[var(--mf-grey)] mt-1">Bildbriefing: Porträt vor Servicefahrzeug oder in der Werkstatt · [OFFEN]</p>
                </div>
              )}
            </div>
          </Reveal>
        </div>

        {/* text */}
        <div className="lg:col-span-7">
          <Reveal><SectionLabel index={index}>Wer ist</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)]">
              {about?.name}
            </h2>
            <p className="font-head text-[1em] text-[var(--mf-grey)] mt-1">{about?.role}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 text-[1.125em] leading-relaxed text-[var(--mf-ink-soft)] max-w-[34em]">
              <RichHTML html={about?.text} />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-3">
              {(about?.qualifications || []).map((q, i) => (
                <span key={i} data-testid={`qualification-${i}`} className="inline-flex items-center gap-2 text-sm font-medium text-[var(--mf-ink)] border border-[var(--mf-line)] px-3.5 py-2">
                  <BadgeCheck size={16} className="text-[var(--mf-red)]" />
                  {q}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              href={about?.linkedin || "https://www.linkedin.com/in/matthias-fenchel-a34099b1/"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-linkedin-btn"
              className="mt-7 inline-flex items-center gap-3 px-5 py-3 text-white font-semibold text-sm rounded-sm transition-transform duration-300 hover:-translate-y-0.5"
              style={{ backgroundColor: "#0A66C2" }}
            >
              <Linkedin size={20} fill="currentColor" strokeWidth={0} />
              Folge mir auf LinkedIn
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
